import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import classnames from 'classnames'
import { OrderedMap } from 'immutable'
import ImmutableProptypes from 'react-immutable-proptypes'

import styles from './styles.css'

class TChart extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    data: ImmutableProptypes.map.isRequired,
  }

  static defaultProps = {
    title: '',
    data: new OrderedMap(),
  }

  state = {}

  render() {
    const { title, data } = this.props

    return (
      <div>
        {title && (
          <div>
            <h2 className={classnames(styles.tableTitle)}>{title}</h2>
            <div style={{ margin: 20 }} />
          </div>
        )}
        <table className={classnames(styles.table)}>
          <tbody>
            {data.entrySeq().map((entry, key) => {
              const temp = entry[0].replace(/([A-Z])/g, ' $1')
              const tableHeader = temp.charAt(0).toUpperCase() + temp.slice(1)
              return (
                <tr key={key} className={classnames(styles.tableRow)}>
                  <th className={classnames(styles.tableText)}>{tableHeader}</th>
                  <td className={classnames(styles.tableText)}>{entry[1]}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }
}

export default TChart



// WEBPACK FOOTER //
// ./src/components/tChart/index.js